import Image from 'next/legacy/image';

import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';
import { Text } from '../Text';
import { Flexbox } from '../Flexbox';

export const BoxWithBorder = styled(Box)<{ isOpen: boolean; color: string }>`
  border-radius: ${({ theme }) => theme.borderRadius.planHeaderMobile};
  overflow: hidden;
  margin-top: ${({ theme }) => theme.spacing.m};
  border: ${({ isOpen, color }) => (isOpen ? `2px solid ${color}` : 'none')};
`;

export const PlanText = styled(Text)<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
`;

export const PlanFeature = styled(Flexbox)`
  padding: ${({ theme }) => `${theme.spacing.m} 0`};
  justify-content: space-between;
  align-items: flex-start;
  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => `1px solid ${theme.color.black}`};
  }
`;

export const ToggleIcon = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? `rotate(45deg)` : 'none')};
  transition: 0.25s transform ease;
`;

export const ClickableFlexbox = styled(Flexbox)<{ color: string }>`
  cursor: pointer;
  background-color: ${({ color }) => `${color}`};
  border-radius: ${({ theme }) =>
    `0 0 ${theme.borderRadius.planHeaderMobile} ${theme.borderRadius.planHeaderMobile}`};
  transition: 0.25s border-radius ease;
`;
